"use client"

import { useState } from 'react'

export default function ImageCaptionInfo({caption, legend}) {
	const [showInfo, setShowInfo] = useState(false);

	return (
		<>
			{(caption || legend) && (
			    <div className="absolute top-8 right-8 isolate">
			      <button
			        className="w-[22px] h-[22px] z-[10] relative rounded-full bg-transparent hover:scale-110 text-white flex items-center justify-center font-serif text-sm font-bold transition-all border border-white"
			        onClick={() => setShowInfo(!showInfo)}
			        aria-label="Show image info"
			      >
			        i
			      </button>

			      {/* Info Popup */}
			      <div style={{width: "max-content"}} 
			        className={`${showInfo && (caption || legend ) ? "opacity-100 scale-100" : "opacity-0 scale-80"} 
			        origin-right transition-all items-end flex-col gap-1 absolute -top-[15px] -right-[12px] bg-black/70 text-white p-3 rounded-3xl backdrop-blur-sm`}
			      >
			        {legend && (
			          <p className="text-[16px] leading-[16px] pr-12">{legend}</p>
			        )}
			        {caption && (
			          <p className="text-[12px] leading-[12px] pr-12 italic w-fit break-keep">&copy;&nbsp;{caption}</p>
			        )}
			      </div>
			    </div>
			)}
		</>
	)
}